export default __webpack_public_path__ + "static/media/vehicleInfoButton.9995fd81.png";